export default {
  path: 'live-tracking',
  name: 'LiveTracking',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/LiveTracking.vue')
}
